import usePrevState from '@hooks/usePrevState';
import { isEqual } from 'lodash';
import { Dispatch, SetStateAction, useEffect } from 'react';

type AtLeastPage = Required<{page: number}>;

interface Params {
    params: AtLeastPage;
    setPage: Dispatch<SetStateAction<number>>;
}
function useResetPage({ params, setPage }:Params) {
    const prevParams = usePrevState(params);
    return useEffect(() => {
        const { page, ...rest } = params;
        const { page: __, ...rest2 } = prevParams;
        if (page !== 0 && !isEqual(rest, rest2)) {
            setPage(0);
        }
    }, [params, prevParams]);
}

export default useResetPage;
